import { render } from "./StatsModal.vue?vue&type=template&id=1d0997db"
import script from "./StatsModal.vue?vue&type=script&lang=js"
export * from "./StatsModal.vue?vue&type=script&lang=js"

import "./StatsModal.vue?vue&type=style&index=0&id=1d0997db&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__